export default "__VITE_ASSET__D1mqu1i4__"